import { useEffect } from "react";

const DEFAULT_TITLE = "Gate, Door & Parking Barrier Manufacturer in Jaipur | Desamatic Automation";
const DEFAULT_DESC =
    "Desamatic Automation manufactures gate openers, door openers, pedestrian openers, parking barriers, access control devices and readers in Jaipur, Rajasthan — supplied and supported across India.";

const setMeta = (selector, attr, value) => {
    const el = document.querySelector(selector);
    if (el && value) el.setAttribute(attr, value);
};

export function useSeo({ title, description, path, jsonLd }) {
    useEffect(() => {
        const origin = window.location.origin;
        const url = `${origin}${path || window.location.pathname}`;
        document.title = title || DEFAULT_TITLE;
        setMeta('meta[name="description"]', "content", description || DEFAULT_DESC);
        setMeta('link[rel="canonical"]', "href", url);
        setMeta('meta[property="og:title"]', "content", title || DEFAULT_TITLE);
        setMeta('meta[property="og:description"]', "content", description || DEFAULT_DESC);
        setMeta('meta[property="og:url"]', "content", url);
        setMeta('meta[name="twitter:title"]', "content", title || DEFAULT_TITLE);
        setMeta('meta[name="twitter:description"]', "content", description || DEFAULT_DESC);
        let script;
        if (jsonLd) {
            script = document.createElement("script");
            script.type = "application/ld+json";
            script.setAttribute("data-page-ld", "1");
            script.text = JSON.stringify(jsonLd);
            document.head.appendChild(script);
        }
        return () => {
            if (script) document.head.removeChild(script);
        };
    }, [title, description, path, jsonLd]);
}
